import { ComponentProps, ReactNode, Suspense } from "react";
import { useTranslation } from "react-i18next";

import { Typography } from "@mui/material";
import { ChunkLoadErrorBoundary, lazyChunk } from "@shared/ChunkLoadErrorBoundary";
import { LoadingBox } from "@shared/Loading";
import { MinimalTableBody, MinimalTableCell, MinimalTableRow } from "@shared/table/MinimalTableComponents";

import type DraggablePolicyRulesBodyComponent from "./DraggablePolicyRulesBody";

const LazyDraggablePolicyRulesBody = lazyChunk(() => import("./DraggablePolicyRulesBody"));

const MessageBody = ({ children }: { children: ReactNode }) => (
    <MinimalTableBody>
        <MinimalTableRow>
            <MinimalTableCell colSpan={4}>{children}</MinimalTableCell>
        </MinimalTableRow>
    </MinimalTableBody>
);

const FailedBody = () => {
    const { t } = useTranslation("common");

    return (
        <MessageBody>
            <Typography color="error">{t("error.failedToLoadFeature")}</Typography>
        </MessageBody>
    );
};

const LoadingBody = () => {
    return (
        <MessageBody>
            <LoadingBox />
        </MessageBody>
    );
};

export const DraggablePolicyRulesBody = (props: ComponentProps<typeof DraggablePolicyRulesBodyComponent>) => (
    <ChunkLoadErrorBoundary fallback={<FailedBody />}>
        <Suspense fallback={<LoadingBody />}>
            <LazyDraggablePolicyRulesBody {...props} />
        </Suspense>
    </ChunkLoadErrorBoundary>
);
